module.exports = __webpack_public_path__ + "static/media/sharks.e661a6d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/game/static/backgrounds/sharks.jpg
// module id = 240
// module chunks = 0